export enum VoiceIntent {
  SEARCH = "search",
  NAVIGATE = "navigate",
  UNKNOWN = "unknown",
}

export interface ParsedIntent {
  intent: VoiceIntent;
  value: string;
  originalTranscript: string;
}

export interface IntentPattern {
  intent: VoiceIntent;
  patterns: RegExp[];
  extractValue: (match: RegExpMatchArray) => string;
}

const INTENT_PATTERNS: IntentPattern[] = [
  {
    intent: VoiceIntent.SEARCH,
    patterns: [
      /^buscar?\s+(.+)$/i,
      /^procurar?\s+(.+)$/i,
      /^pesquisar?\s+(.+)$/i,
      /^encontrar?\s+(.+)$/i,
      /^quero\s+(?:buscar|procurar|pesquisar)\s+(.+)$/i,
    ],
    extractValue: (match) => match[1].trim(),
  },
  {
    intent: VoiceIntent.NAVIGATE,
    patterns: [
      /^(?:ir|abrir|acessar|navegar)\s+(?:para|a|ao|à)?\s*(.+)$/i,
      /^(?:mostrar|exibir)\s+(.+)$/i,
      /^quero\s+(?:ir|acessar|ver)\s+(?:para|a|ao|à)?\s*(.+)$/i,
    ],
    extractValue: (match) => match[1].trim(),
  },
];

export function normalize(s: string) {
  return s
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function parseIntent(transcript: string): ParsedIntent {
  const normalizedTranscript = normalize(transcript);

  for (const intentPattern of INTENT_PATTERNS) {
    for (const pattern of intentPattern.patterns) {
      const match = normalizedTranscript.match(pattern);

      if (match) {
        const originalMatch = transcript.trim().toLowerCase().match(pattern);
        return {
          intent: intentPattern.intent,
          value: intentPattern.extractValue(originalMatch ?? match),
          originalTranscript: transcript,
        };
      }
    }
  }

  return {
    intent: VoiceIntent.UNKNOWN,
    value: normalizedTranscript,
    originalTranscript: transcript,
  };
}
